<section
  class="flex items-center justify-center min-h-screen"
  *ngIf="!isPwdSuccessfullyReset"
>
<div class="flex flex-col p-10 items-center bg-white shadow-lg rounded-lg w-[390px] 3xl:w-[520px] 4xl:w-[620px] containerLogin">

    <div class="w-full mb-4" *ngIf="step == 'code'" (click)="goBack()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="size-6 cursor-pointer text-black"
      >
        <path
          fill-rule="evenodd"
          d="M7.28 7.72a.75.75 0 0 1 0 1.06l-2.47 2.47H21a.75.75 0 0 1 0 1.5H4.81l2.47 2.47a.75.75 0 1 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 0 1 1.06 0Z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <!-- Step 1: Enter Username -->
    <div class="w-80 3xl:w-100 4xl:w-130" *ngIf="step === 'username'">
      <p class="text-[0.85em] 3xl:text-[1em] 4xl:text-[1.15em] text-gray-700 mb-9">
        Un codice di verifica verrà inviato al tuo indirizzo email.
      </p>
      <label for="usernameReset" class="block text-dimot-1 mb-2 text-[0.8em] 3xl:text-[0.95em] 4xl:text-[1.1em]"
        >Inserisci il tuo nome utente:</label
      >
      <!-- <input type="text" id="usernameReset" [(ngModel)]="username" class="w-full border border-gray-300 p-3 rounded-lg mt-1"/> -->
      <!-- INSTEAD FOR NOW -->
      <input
        [(ngModel)]="username"
        type="text"
        id="usernameReset"
        class="w-full h-12 3xl:h-14 4xl:h-16 3xl:mt-3 4xl:mt-5 text-sm 3xl:text-[1.1em] 4xl:text-[1.3em] text-black mx-auto block border border-gray-300 bg-[#cecece2c] p-3 rounded-lg mt-1"
      />
      <button
        type="button"
        class="w-full cursor-pointer h-12 3xl:h-14 4xl:h-16 bg-dimot-1 text-white text-[0.8em] 3xl:text-[0.9em] 4xl:text-[1.05em] p-3 rounded-lg mt-8 hover:bg-[#20329d] transition mx-auto block"
        (click)="requestPasswordReset()"
      >
        INVIA CODICE DI VERIFICA
      </button>
    </div>

    <!-- Step 2: Enter Code -->
    <div class="w-80 3xl:w-90 4xl:w-100" *ngIf="step === 'code'">
      <p class="text-[0.85em] 3xl:text-[1em] 4xl:text-[1.15em] text-gray-700">
        Un codice di verifica è stato inviato a <strong>{{ email }}</strong
        >.
      </p>
      <p class="text-[0.85em] 3xl:text-[1em] 4xl:text-[1.15em] text-gray-700 mb-8">Inseriscilo qui sotto:</p>
      <label
        for="verificationCode"
        class="block text-gray-600 mb-2 text-[0.8em] 3xl:text-[0.95em] 4xl:text-[1.1em]"
        >Codice di verifica:</label
      >
      <!-- <input type="number" id="verificationCode" [(ngModel)]="verificationCode" class="w-full border border-gray-300 p-3 rounded-lg mt-1"/> -->
      <!-- INSTEAD FOR NOW -->
      <input
        type="number"
        id="verificationCode"
        [(ngModel)]="verificationCode"
        class="w-full h-12 3xl:h-14 4xl:h-16 3xl:mt-3 4xl:mt-5 text-sm 3xl:text-[1.1em] 4xl:text-[1.3em] text-gray-900 text-[0.85em] mx-auto block border border-gray-300 bg-[#cecece2c] p-3 rounded-lg mt-1 appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      />
      <label
        for="newPassword"
        class="block text-gray-600 mt-4 mb-2 text-[0.8em] 3xl:text-[0.95em] 4xl:text-[1.1em]"
        >Inserisci la tua nuova password:</label
      >
      <div class="relative w-full">
        <!-- <input [type]="passwordFieldType" id="newPassword" [(ngModel)]="newPassword" class="w-full border border-gray-300 p-3 rounded-lg pr-10"/> -->
        <!-- INSTEAD FOR NOW -->
        <input
          [type]="passwordFieldType"
          [(ngModel)]="newPassword"
          (focus)="showTooltip = true"
          (blur)="showTooltip = false"
          (input)="validatePassword()"
          id="newPassword"
          class="w-full text-gray-900 h-12 3xl:h-14 4xl:h-16 3xl:mt-3 4xl:mt-5 text-sm 3xl:text-[1.1em] 4xl:text-[1.3em] mx-auto block border border-gray-300 bg-[#cecece2c] p-3 rounded-lg mt-1"
        />
        <!-- Bottone per togglare la visibilità della password -->
        <button
          type="button"
          (click)="togglePasswordVisibility()"
          class="absolute inset-y-0 right-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-hidden focus:text-blue-600 dark:text-neutral-600 dark:focus:text-blue-500"
        >
          <!-- Occhio aperto -->
          <svg
            *ngIf="passwordFieldType === 'password'"
            class="w-6 h-6 text-gray-400 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-width="2"
              d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
            />
            <path
              stroke="currentColor"
              stroke-width="2"
              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
          </svg>

          <!-- Occhio chiuso -->
          <svg
            *ngIf="passwordFieldType === 'text'"
            class="w-6 h-6 text-gray-400 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
          </svg>
        </button>
        <!-- Password Requirements Tooltip -->
        <div
          *ngIf="showTooltip"
          class="tooltip-password border border-gray-200 rounded-[8px] p-2 bg-gray-50 absolute text-[0.8rem]"
          style="
            bottom: 100%;
            left: 0;
            margin-bottom: 10px;
            width: 100%;
            z-index: 1000;
          "
        >
          <div
            class="tooltip-arrow shadow"
            data-popper-arrow
            style="
              position: absolute;
              bottom: 4px;
              width: 0;
              height: 0;
              z-index: 1 !important;
              border-left: 6px solid #e5e7eb !important;
              border-right: 6px solid #e5e7eb !important;
              border-top: 6px solid #f9fafb; /* match the tooltip border */
            "
          ></div>
          <span class="font-bold text-black">Requisiti:</span>
          <ul class="mb-0 pl-3">
            <li [class.text-success]="passwordValidations.minLength">
              <i
                [class]="
                  passwordValidations.minLength
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Minimo 8 caratteri
            </li>
            <li [class.text-success]="passwordValidations.number">
              <i
                [class]="
                  passwordValidations.number
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno un numero
            </li>
            <li [class.text-success]="passwordValidations.lowercase">
              <i
                [class]="
                  passwordValidations.lowercase
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno una lettera minuscola
            </li>
            <li [class.text-success]="passwordValidations.uppercase">
              <i
                [class]="
                  passwordValidations.uppercase
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno una lettera maiuscola
            </li>
            <li [class.text-success]="passwordValidations.specialChar">
              <i
                [class]="
                  passwordValidations.specialChar
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno un carattere speciale
              <small class="ms-1 text-muted">(+, #, $, %, *, ., !, -)</small>
            </li>
          </ul>
        </div>
      </div>
      <!-- <button class="w-full bg-green-500 text-white p-3 rounded-lg mt-4" (click)="confirmPasswordReset()">REIMPOSTA PASSWORD</button> -->
      <!-- INSTEAD FOR NOW -->
      <button
        class="w-full h-12 3xl:h-14 4xl:h-16 bg-[#07ad9f] text-white text-[0.8em] 3xl:text-[0.9em] 4xl:text-[1.05em] p-3 rounded-lg mt-8 hover:bg-[#09c6b6] transition mx-auto block cursor-pointer"
        (click)="confirmPasswordReset()"
      >
        REIMPOSTA PASSWORD
      </button>
    </div>
    <!-- Error Message -->
    <div
      *ngIf="errorMessage"
      class="w-full text-red-500 text-center text-[0.85em] 3xl:text-[1em] 4xl:text-[1.15em] mt-6"
    >
      {{ errorMessage }}
    </div>

    <span
      class="text-[#4f5984] cursor-pointer mt-8 block mx-auto text-[0.8em] 3xl:text-[0.95em] 4xl:text-[1.1em]"
      (click)="backToLogin()"
      >Torna al login</span
    >
  </div>
</section>

<!-- Modal: Password successfully reset -->
<section
  class="fixed inset-0 flex items-center justify-center"
  *ngIf="isPwdSuccessfullyReset"
>
  <div
    class="bg-white p-8 rounded-lg shadow-lg text-center w-[420px] containerLogin"
  >
    <i class="fa-regular fa-circle-check text-green-500 text-4xl mb-3"></i>
    <h5 class="text- font-bold text-black">
      Password reimpostata con successo!
    </h5>
    <p class="text-gray-700 mt-2">
      Ora puoi accedere con la tua nuova password.
    </p>
    <button
      class="w-full cursor-pointer bg-[#07ad9f] text-[0.88em] text-white mx-auto block p-3 rounded-lg mt-6 hover:bg-[#09c6b6] transition"
      (click)="backToLogin()"
    >
      Torna al login
    </button>
  </div>
</section>
